import { Url } from '../route/router';

export const callbackUrlQueryParam = 'callbackUrl';

function urlPatternFromTemplate(template: string): RegExp {
  // escape regex special chars except `/` and `[]`
  const escaped = template.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  // replace [param] with a wildcard matcher
  const regexString = '^' + escaped.replace(/\\\[.+?\\]/g, '[^/]+') + '$';
  return new RegExp(regexString);
}

function buildAllowedPatterns(urls: Record<string, string>): RegExp[] {
  return Object.values(urls).map(urlPatternFromTemplate);
}

const allowedPatterns = buildAllowedPatterns(Url);

export function isAllowedCallbackUrl(path: string): boolean {
  return allowedPatterns.some((pattern) => pattern.test(path));
}
